import apiManager from '@/api';

const module = {
  namespaced: true,
  state: () => ({
    events: [],
    loaded: false,
  }),
  mutations: {
    setEvents(state, events) {
      state.events = events;
      state.loaded = true;
    },
    loadEvent(state, event) {
      const index = state.events.findIndex((ev) => ev.id === event.id);
      if (index > -1) {
        state.events.splice(index, 1, event);
        return;
      }

      state.events.push(event);
    },
  },
  getters: {
    event: (state) => (id) => state.events.find((event) => event.id === id),
  },
  actions: {
    async loadEvents({ commit }) {
      const events = await apiManager.events.getAll();
      commit('setEvents', events);
    },
    async loadEvent({ commit }, { id, email }) {
      const { data } = await apiManager.events.loadEvent({ id, email });
      commit('loadEvent', data);
    },
  },
};

export default module;
